import { RestSchemas } from '@/contexts/QueryProvider'
import { ColumnDef } from '@tanstack/react-table'
import { SortingHeaderButton } from '../../../../components/ui/DataTable/SortingHeaderButton'
import { OrganisationLink } from './OrganisationLink'
import { Link } from 'react-router'
import { IconAvatarOutline } from '@icons/IconAvatarOutline'
import { NumberBadge } from '@/components/ui/DataTable/NumberBadge'
import { IconOpenInNewOutline } from '@icons/IconOpenInNewOutline'
import { IconCommunityOutline } from '@icons/IconCommunityOutline'
import { IconWebcastOutline } from '@icons/IconWebcastOutline'
import { RowActionsMenu } from './RowActionsMenu'
import { ProjectIcon } from '@/const'

type MessagesSubscriptionsOrganisationSummary = RestSchemas['Messages.Subscriptions.OrganisationSummary']

export const columns: ColumnDef<MessagesSubscriptionsOrganisationSummary>[] = [
  {
    id: 'name',
    accessorFn: (row) => `${row.name} ${row.description}`,
    header: ({ column }) => <SortingHeaderButton column={column}>Organisation</SortingHeaderButton>,
    cell: ({ row }) => <OrganisationLink item={row.original} />,
    sortingFn: (rowA, rowB) => rowA.original.name.localeCompare(rowB.original.name),
    size: 250,
  },
  {
    id: 'users',
    accessorFn: (row) => row.users,
    header: ({ column }) => <SortingHeaderButton column={column}>Users</SortingHeaderButton>,
    cell: ({ row }) => (
      <Link
        to={`${row.original.id}/users`}
        // className={clsx('text-muted-foreground')}
        className="group flex items-center gap-x-2 p-1.5 text-muted-foreground"
      >
        <IconAvatarOutline className="size-5" />
        <NumberBadge value={row.original.users} />
        <IconOpenInNewOutline className="ml-5 hidden size-4 shrink-0 self-center text-primary group-hover:block" />
      </Link>
    ),
  },
  {
    id: 'projects',
    accessorFn: (row) => row.projects,
    header: ({ column }) => <SortingHeaderButton column={column}>Projects</SortingHeaderButton>,
    cell: ({ row }) => (
      <Link to={`${row.original.id}/projects`} className="group flex items-center gap-x-2 p-1.5 text-muted-foreground">
        <ProjectIcon className="size-5" />
        <NumberBadge value={row.original.projects} />
        <IconOpenInNewOutline className="ml-5 hidden size-4 shrink-0 self-center text-primary group-hover:block" />
      </Link>
    ),
  },
  {
    id: 'projectTeams',
    accessorFn: (row) => row.projectTeams,
    header: ({ column }) => <SortingHeaderButton column={column}>Project teams</SortingHeaderButton>,
    cell: ({ row }) => (
      <Link to={`${row.original.id}/teams`} className="group flex items-center gap-x-2 p-1.5 text-muted-foreground">
        <IconCommunityOutline className="size-5" />
        <NumberBadge value={row.original.projectTeams} />
        <IconOpenInNewOutline className="ml-5 hidden size-4 shrink-0 self-center text-primary group-hover:block" />
      </Link>
    ),
  },
  {
    id: 'workspaces',
    accessorFn: (row) => row.workspaces,
    header: ({ column }) => <SortingHeaderButton column={column}>Workspaces</SortingHeaderButton>,
    cell: ({ row }) => (
      <Link
        to={`${row.original.id}/workspaces`}
        className="group flex items-center gap-x-2 p-1.5 text-muted-foreground"
      >
        <IconWebcastOutline className="size-5" />
        <NumberBadge value={row.original.workspaces} />
        <IconOpenInNewOutline className="ml-5 hidden size-4 shrink-0 self-center text-primary group-hover:block" />
      </Link>
    ),
  },
  {
    id: 'actions',
    // header: 'Actions',
    cell: ({ row }) => (
      <div className="flex justify-end pr-5">
        <RowActionsMenu org={row.original} />
      </div>
    ),
  },
]
